import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const PersonAndCogsIllustration = ({
  width = 250,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 66 47">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(21 26)">
          <path
            fill="#94C9E2"
            d="M28.855.261l-5.914 5.794L17.029.261C7.751 2.794.942 11.111.942 21.001h44c0-9.89-6.813-18.207-16.087-20.74"
          />
        </g>
        <g transform="translate(32)">
          <path
            fill="#94C9E2"
            d="M23.672 11.73c0 6.48-5.252 11.73-11.73 11.73-6.479 0-11.73-5.25-11.73-11.73C.211 5.253 5.462 0 11.941 0c6.478 0 11.73 5.252 11.73 11.73"
          />
        </g>
        <path
          fill="#1D1D1B"
          d="M43.942 23.461c-.69 0-4.266-5.252-4.266-11.73 0-6.479 3.606-11.73 4.266-11.73-6.48 0-11.73 5.251-11.73 11.73 0 6.478 5.25 11.73 11.73 11.73"
          opacity=".1"
        />
        <path
          fill="#00396C"
          d="M23.374 38.198c-3.537-.005-6.4-2.876-6.395-6.413.005-3.536 2.876-6.4 6.413-6.394 3.537.005 6.399 2.876 6.394 6.412-.005 3.537-2.876 6.4-6.412 6.395m8.589-6.216c0-.221 0-.465-.024-.685l2.479-1.633-3.668-6.356-2.503 1.658c-.392-.27-.76-.49-1.176-.685l.004-3.298-3.677-.005-3.677-.006-.005 3.298c-.417.195-.785.414-1.178.682l-2.498-1.664-3.687 6.345 2.474 1.64c-.024.22-.024.465-.025.684 0 .22 0 .464.023.684l-2.478 1.633 3.669 6.356 2.503-1.658c.39.27.759.49 1.175.686l-.005 3.379 3.678.005 3.677.006.005-3.38c.417-.194.785-.413 1.178-.681l2.499 1.664 3.686-6.346-2.475-1.64c.026-.22.026-.464.026-.683"
        />
        <g transform="translate(0 15)">
          <path
            fill="#00396C"
            d="M6.775 11.022c-2.173-.003-3.932-1.767-3.93-3.94.004-2.173 1.768-3.932 3.94-3.93 2.174.005 3.933 1.768 3.929 3.94-.002 2.174-1.766 3.933-3.94 3.93m5.278-3.82c0-.135 0-.284-.014-.42l1.523-1.003-2.254-3.905-1.538 1.018c-.241-.165-.467-.301-.723-.421L9.049.445 6.789.442 4.532.439l-.003 2.026c-.257.119-.482.254-.724.419L2.269 1.86.004 5.76l1.52 1.008c-.016.134-.016.285-.016.42s0 .285.015.42L0 8.61l2.254 3.905 1.538-1.018c.24.166.466.3.722.42l-.003 2.077 2.26.004 2.259.003.003-2.076c.257-.12.482-.255.723-.42l1.536 1.023 2.264-3.9-1.52-1.006c.016-.135.016-.286.016-.42"
          />
        </g>
        <path fill="#1D1D1B" d="M43.942 47h-22c0-9.89 6.81-18.206 16.087-20.74l5.912 5.795V47z" opacity=".1" />
      </g>
    </svg>
  </DefaultIconWrapper>
);
